export default "__VITE_ASSET__BNpTyaVF__"